import { render } from "./CreateClassroomModal.vue?vue&type=template&id=f7a09ab2"
import script from "./CreateClassroomModal.vue?vue&type=script&lang=js"
export * from "./CreateClassroomModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__